module.exports = __webpack_public_path__ + "static/media/tachometer-alt-fast.504b567b.svg";